import React from 'react';
import * as C from '../common-styles.styles';
import SeoCard from './route-card/route-card';

const RouteCard = props => {
  const { routesList, airlineInfo, type, isDweb = false } = props;
  if (!routesList || routesList.length <= 0) {
    return null;
  }
  const { code, name } = airlineInfo;

  return (
    <>
      <C.Wrap className="flexCol" isDweb={isDweb}>
        <C.Headings className="padB5" isDweb={isDweb}>
          {`${name} Airlines Popular ${type} Routes`}
        </C.Headings>
        <C.LabelRoutes className="dF width100 padT5 padB5">
          <div className="flex1 greyCnt">Airline</div>
          <div className="flex1 greyCnt">From</div>
          <div className="flex1 greyCnt">&nbsp;</div>
          <div className="flex1 greyCnt">To</div>
          <div className="flex1 flexCol greyCnt alignItemsCenter">Cheapest Fare</div>
          {isDweb ? <div className="flex1">&nbsp;</div> : null}
        </C.LabelRoutes>
        {routesList.map(
          (route, index) =>
            route && (
              <SeoCard
                key={index}
                airlineCode={code}
                airlineName={name}
                sourceIata={route?.sourceIata}
                sourceName={route?.sourceName}
                destIata={route?.destIata}
                destName={route?.destName}
                price={route?.price}
                url={route.url}
                isDweb={isDweb}
              />
            )
        )}
      </C.Wrap>
    </>
  );
};

export default RouteCard;
